import React, { useEffect, useState } from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../features/auth/authSlice';

const Documents = ({ documents = [] }) => {
    const token = useSelector(selectCurrentToken);
    const [resolvedDocuments, setResolvedDocuments] = useState([]);

    useEffect(() => {
        const controller = new AbortController();
        const objectUrls = [];
        Promise.all(documents.map(async document => {
            if (document?.url) return document;
            const fileName = typeof document === 'string' ? document : document.fileName;
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/master/document/${encodeURIComponent(fileName)}`, {
                headers: { Authorization: `Bearer ${token}` }, signal: controller.signal
            });
            if (!response.ok) throw new Error('DocumentLoadFailed');
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            objectUrls.push(url);
            return { ...(typeof document === 'object' ? document : {}), fileName, url, mime: blob.type };
        })).then(setResolvedDocuments).catch(error => {
            if (error.name !== 'AbortError') setResolvedDocuments([]);
        });
        return () => {
            controller.abort();
            objectUrls.forEach(URL.revokeObjectURL);
        };
    }, [documents, token]);

    const label = document => document.kind === 'passport1' ? '1' : document.kind === 'passport2' ? '2' : 'ITN';
    return <div className="col-xl-12 padding-bottom-15 padding-left-0" style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem' }}>
        <PhotoProvider>
            {resolvedDocuments.map((document, index) => (document.mime === 'application/pdf' || /\.(heic|heif)$/i.test(document.fileName))
                ? <a key={`${document.fileName}-${index}`} href={document.url} target="_blank" rel="noreferrer"
                    className="dashboard-box" style={{ width: '11rem', height: '9rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <i className="icon-feather-file-text" style={{ fontSize: '38px' }}></i><span>{document.mime === 'application/pdf' ? 'PDF' : 'HEIC'} {label(document)}</span>
                </a>
                : <PhotoView key={`${document.fileName}-${index}`} src={document.url}>
                    <img style={{ objectFit: 'cover', width: '11rem', height: '9rem', maxWidth: '100%', cursor: 'pointer' }} src={document.url} alt={label(document)} />
                </PhotoView>)}
        </PhotoProvider>
    </div>;
};

export default Documents;
